import { LIVE, SUNSET } from '../../RolloutTypes';
const productUpdateValidations = [{
  key: 'title',
  errorMessage: 'Missing title',
  validateFunc: title => title !== ''
}, {
  key: 'stageDate',
  errorMessage: 'Missing stage date',
  validateFunc: date => date !== null
}, {
  key: 'featureGroups',
  errorMessage: 'Missing feature groups',
  validateFunc: featureGroups => featureGroups.length > 0
}];
const rolloutValidations = [{
  key: 'impactLevel',
  errorMessage: 'Missing rollout impact level',
  validateFunc: impactLevel => impactLevel !== null
}, {
  key: 'products',
  errorMessage: 'Missing rollout products',
  validateFunc: products => products.length > 0
}];
export const validatePUData = pu => {
  const puErrors = productUpdateValidations.reduce((errors, {
    key,
    errorMessage,
    validateFunc
  }) => {
    if (!validateFunc(pu[key])) {
      errors += `, ${errorMessage}`;
    }
    return errors;
  }, '');
  /**
   * Ignoring PUs that are in LIVE/SUNSET state and older than 1 year as they have incomplete data
   * Impact level and products were introduced after these PUs went live.
   * @deprecated Should cleanup this check after these older PUs are no longer surfacing (5/30/2025)
   *  */
  const ignoreDate = new Date(1685592000); // June 1, 2023
  const ignorePU = (pu.rolloutState === LIVE || pu.rolloutState === SUNSET) && pu.stageDate < ignoreDate.getTime() * 1000;
  const rolloutErrors = ignorePU ? '' : rolloutValidations.reduce((errors, {
    key,
    errorMessage,
    validateFunc
  }) => {
    if (!validateFunc(pu.rollout[key])) {
      errors += `, ${errorMessage}`;
    }
    return errors;
  }, '');
  // remove the comma and space at the beginning
  return (puErrors + rolloutErrors).substring(2);
};